import React from 'react';
import SummaryTournament from './SummaryTournament';
import Image from 'react-bootstrap/Image';


class Camisetas extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      showCards: true,
	kit_path: '/images_fem/kits/todas/',
	kits: [],
      id_list: []
    };
  }

  componentDidMount(){ 

    for(var i= 1; i <= 300; i++){
		this.state.id_list.push(i);
	}

	this.getKits();
  }

getKits(){

        fetch("https://www.registrosudec.com:5000/onlykits_fem", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", soc$
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}

  render(){

  // Remove any existing entry with path: 100
  const index100 = this.state.kits.findIndex(k => k.path === 100);
  if (index100 !== -1) {
    this.state.kits.splice(index100, 1);
  }

  // Find index of path 47
  const index47 = this.state.kits.findIndex(k => k.path === 47);
  // Find index of path 48
  const index48 = this.state.kits.findIndex(k => k.path === 48);

  // Insert between path 47 and 48
  if (index47 !== -1 && index48 !== -1 && index48 === index47 + 1) {
    this.state.kits.splice(index47 + 1, 0, { count: 1, path: 100 }); // Adjust count as needed
  }

    return(



      <div style={{textAlign: 'center' }}>
      <div style={{ height: '30px' }}></div>
	<div className="mytitlepartidos"> Camisetas utilizadas desde 2016 </div>
      <div style={{textAlign: 'center' }}>
	<div style={{ height: '20px' }}></div>
      <Image  className="myescudo-away-main"  src={'/images/escudos/udeconce.png'}/>
      </div>

      <div style={{ height: '50px' }}></div>

	<div style={{ height: '50px' }}></div> 


<div style={{ display: 'inline-block' }}>
  <table style={{ textAlign: 'center'}}>
    {
      // Split kits into rows of 5
      [...Array(Math.ceil(this.state.kits.length / 5))].map((_, rowIndex) => {
        const rowItems = this.state.kits.slice(rowIndex * 5, rowIndex * 5 + 5);
        return (
          <React.Fragment key={rowIndex}>
            <tr>
              {rowItems.map(i => (
                <td key={`img-${i.path}`} style={{ padding: '10px 15px' }}>
                  <Image className="escudo-home" src={this.state.kit_path + i.path + ".png"} />
                </td>
              ))}
            </tr>
            <tr>
              {rowItems.map(i => (
                <td key={`count-${i.path}`} className="circle"  >
                  {i.count}
                </td>
              ))}
            </tr>
		<tr>
          <td colSpan={5} style={{ height: '30px' }}></td>
        </tr>
          </React.Fragment>
        );
      })
    }
  </table>
</div>


<div style={{ height: '70px' }}></div>





        
        <div style={{ height: '70px' }}></div>

     </div>

    )

}
}
export default Camisetas;
